<template>
  <div class="dailyVideo-page">
    <div class="page-left_panel">
      <panelLeft
        ref="panel"
        @open="openMedia"
        :camData="camData"
        :isAddCollection="isAdd"
        @invokingFunction="invokingFunction"
        @openCollection="openCollection"
      ></panelLeft>
    </div>
    <div class="page-right_panel" id="content-right">
      <media-player
        @playTour="playTour"
        ref="mediaPlayer"
        @playVideoOK="playVideoOK"
        @playBackOk="playBackOk"
        @stopAll="stopAll"
        :playDeviceData="playDeviceData"
        @handleShowVideos="handleShowVideos"
        @changeWindowNumber="changeWindowNumber"
      ></media-player>
      <back-videos
        v-if="isVideos"
        :videos-data="queryBackData"
        :start-time="searchVideoStartTime"
        :end-time="searchVideoEndTime"
        :left="vStyle.left"
        :width="vStyle.width"
        :play-time="playTime"
        ref="backVideos"
        :wnd="backVideoWnd"
        @handlePlayBackSingleVideo="handlePlayBackSingleVideo"
        @handlePlayBackVideo="handlePlaySearchVideo"
        @handleSetActiveWnd="handleSetActiveWnd"
        @handleDownloadVideo="handleDownloadVideo"
      ></back-videos>
      <!-- <video-control-player ref="control"></video-control-player> -->
    </div>
    <add-collection-panel
      :camData="camData"
      :isOcx="true"
      ref="collection"
      @refresh="refreshData"
    ></add-collection-panel>
  </div>
</template>

<script>
import panelLeft from "../components/realTime/panel-left";
// 录像搜索结果
import AddCollectionPanel from "../components/realTime/add-collection-panel";
import BackVideos from "../components/realTime/back-videosNew";
import mediaPlayer from "../components/realTime/Window";
// import videoBox from "@src/components/common/media-player/video-playerNew.vue";
export default {
  components: {
    panelLeft,
    BackVideos,
    // videoControlPlayer,
    AddCollectionPanel,
    mediaPlayer,
  },
  props: {
    camData: {
      type: Array,
      default: () => [],
    },
    isAdd: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      windowNumber: 4,
      curTour: [],
      backVideoWnd: 1,
      isVideos: false,
      playType: "video-live",
      vStyle: {
        left: "462px",
        top: "101px",
        paddingLeft: "0px",
        paddingRight: "0px",
        zIndex: 90,
        width: document.body.clientWidth - 488 + "px",
        height: "420px",
      },
      searchVideoStartTime: 0,
      searchVideoEndTime: 0,
      cameraCode: "",
      isShowBar: false,
      listenerTime: false,
      playTime: null,
      tourTimer: null,
      curSceneTime: 0,
      curSceneName: "暂无",
      // queryBackData: null,
      queryBackData: [
        // {
        //   ability: "0",
        //   cameraType: null,
        //   children: null,
        //   deviceType: "18",
        //   distance: null,
        //   faultCount: null,
        //   id: "20221117216092",
        //   inlineCount: 0,
        //   isLeaf: "0",
        //   latitude: "35.2924920000",
        //   longitude: "118.0440630000",
        //   name: "西安大路街口",
        //   nodeType: "device",
        //   parentId: "200000001",
        //   status: "1",
        //   thirdCameraId: "78-DE-FZ_1",
        //   totalCount: 0,
        // },
      ],
      // 当前播放的设备 点击ocx的关闭按钮无感
      playDeviceData: [],
    };
  },
  beforeDestroy() {
    // busVue.$off("sessionVideo");
    clearTimeout(this.timer);
    clearInterval(this.intervalTimer);
  },
  methods: {
    //回放
    playBackOk(option) {
      console.log(
        option,
        option.startTime.valueOf(),
        new Date(option.startTime).getTime(),
        "playBackOk"
      );
      this.searchVideoStartTime = new Date(option.startTime).getTime();
      this.searchVideoEndTime = new Date(option.endTime).getTime();
      console.log(
        option,
        option.startTime.valueOf(),
        new Date(option.startTime).getTime(),
        "playBackOk"
      );
      this.isVideos = true;
      this.$refs.panel.searchLoading = false;
      // this.searchVideoStartTime=option
      // this.queryBackData = {
      //   0: data,
      // };
      this.queryBackData.push(option.deviceObj);
      // this.se
    },
    handleShowVideos() {
      this.isVideos = !this.isVideos;
    },
    //单个点击播放
    handlePlayBackSingleVideo(option) {
      console.log(
        "dange1",
        option,
        option.startTime.toFixed(0),
        new Date(option.endTime),
        new Date(option.startTime.toFixed(0))
      );
      // let params = {
      //   startTime: option.startTime,
      //   endTime: option.endTime,
      //   deviceObj: option.deviceObj,
      // };
      let arr = [];
      this.$nextTick(() => {
        arr = this.$refs.mediaPlayer.$refs.player.windowVideoArr;
        arr.forEach((el, index) => {
          if (el.thirdCameraId == option.deviceObj.thirdCameraId) {
            imosSdk.playRecord(
              el.iframeID,
              el.thirdCameraId,
              option.deviceObj.name + "录像回放",
              new Date(option.startTime),
              new Date(option.endTime),
              (result) => {
                if (result.ErrCode === 0) {
                  // this.isVideos=true;
                  // this.$emit("playBackOk", params);
                  console.log("播放成功", result);
                } else {
                  console.log("播放失败" + result.ErrMsg);
                }
                console.log(result, "====lu像播放");
              }
            );
          }
        });
        console.log(
          "单个拆查询",
          this.$refs.mediaPlayer.$refs.player.windowVideoArr
        );
        // this.$refs.mediaPlayer.handlePlayBackSingleVideo(params);
      });
    },
    /**
     * 双击刻度信息播放录像信息
     * @param obj
     */
    handlePlaySearchVideo(obj) {
      console.log("cameraDataList", this.cameraDataList);
      this.isShowBar = true;
      this.startTime = obj.StartTime;
      this.endTime = obj.EndTime;
      this.cameraCode = obj.cameraCode;
      this.cameraName = obj.cameraName;
      this.listenerTime = true;
      const param = {
        deviceId: obj.cameraCode,
        startTime: obj.StartTime,
        endTime: obj.EndTime,
      };
      this.$refs.mediaPlayer.handlePlayBackVideo(param);
    },
    async sceneDisplay() {
      await this.stopAllVideo();
      this.intervalTimer ? clearInterval(this.intervalTimer) : "";
      this.curScene = this.curTour[this.curSceneIndex];
      this.curSceneName = this.curScene.tourSceneName;
      this.$refs.mediaPlayer.changeWindowNumber(
        Number(this.curScene.tourSceneScreen)
      );
      this.curSceneTime = Number(
        this.curTour[this.curSceneIndex].tourSceneTime
      );
      // this.timer = setTimeout(() => {
      this.curTour[this.curSceneIndex].tourSceneCameraInfoList.map(
        (item, index) => {
          // this.timer = setTimeout(() => {
          this.$refs.mediaPlayer.handlePlay(
            {
              thirdCameraId: item.thirdDeviceId,
              deviceId: item.thirdDeviceId,
              deviceName: item.deviceName,
            },
            index + 1
          );
          // }, 300);
        }
      );
      this.intervalTimer = setInterval(() => {
        if (!this.curSceneTime || this.curSceneTime <= 0) {
          if (this.curSceneIndex < this.curTour.length) {
            this.curSceneIndex++;
            this.sceneDisplay();
          } else {
            this.$message.success({
              title: "提示",
              message: "当前轮巡已播放完成",
              type: "success",
            });
            this.curSceneIndex = 0;
          }
          clearInterval(this.intervalTimer);
        } else {
          this.curSceneTime--;
        }
      }, 1000);
    },
    /**
     * 设置窗格选中
     * @param wnd
     */
    handleSetActiveWnd(wnd) {
      if (!this.ocx) {
        return;
      }
      if (this.isFD) {
        this.setLayout(this.windowNumber);
        this.isFD = false;
      }
    },
    // 录像下载
    handleDownloadVideo(row) {
      console.log(row, "====录像下载");
      // if (row) {
      //   this.currentDownloadInfo = row;
      // } else {
      //   this.currentDownloadInfo = {
      //     cameraCode: this.cameraCode,
      //     StartTime: this.startTime,
      //     EndTime: this.endTime,
      //   };
      // }
      // this.downLoadVisible = true;
    },
    playVideoOK(data) {
      // 视频播放成功回调渲染摄像机列表
      this.$children[0].$refs.deviceTree.showIcon(data);
      //  this.$refs.deviceTree.showIcon(data);
    },
    // 清除所有播放窗口信息
    stopAll() {
      this.playDeviceData = [];
      this.intervalTimer ? clearInterval(this.intervalTimer) : "";
    },
    changeWindowNumber(num) {
      this.windowNumber = num;
    },
    openMedia(data, num) {
      console.log("data", data);
      this.$refs.mediaPlayer.handlePlay(data);
      this.handlePlaySuccess();
      num > 4 && num <= 9
        ? (this.$refs.mediaPlayer.$refs.player.windowNumber = 9)
        : num > 9
        ? (this.$refs.mediaPlayer.$refs.player.windowNumber = 16)
        : "";
    },
    handlePlaySuccess() {
      this.$refs.mediaPlayer.playSuccess();
    },
    playTour() {
      if (!this.curTour || !this.curTour.length) {
        this.$message.warning("请先选择配置有场景的轮巡");
      } else {
        this.sceneDisplay();
      }
    },
    //云台控制
    invokingFunction(funcName, param) {
      this.$refs.mediaPlayer[funcName](param);
    },
    openCollection(data) {
      this.$nextTick(() => {
        this.$refs["collection"].open(data);
      });
    },
    refreshData() {
      this.$refs["panel"].refreshCollectionData();
    },
  },
};
</script>

<style lang="scss" scope>
#content-right {
  padding: 10px;
  overflow: hidden;
  height: 100%;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
}
.dailyVideo-page {
  width: 100%;
  height: 100%;
  display: flex;
  // .page-left_panel {
  //   width: 19%;
  // }
  .page-right_panel {
    margin-left: 14px;
    width: 100%;
  }
}
.page-container {
  display: flex;
}
</style>